import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=4a20fdce&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=4a20fdce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20fdce",
  null
  
)

export default component.exports